export default "__VITE_ASSET__CBK3KHhI__"